import { render, staticRenderFns } from "./RecommendationRating.vue?vue&type=template&id=e96d32d0&"
import script from "./RecommendationRating.vue?vue&type=script&lang=js&"
export * from "./RecommendationRating.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationRating.vue?vue&type=style&index=0&id=e96d32d0&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VRating,VTooltip})
